var exports = {
  "dK": "MessageComponents.module__components___UmFBWT",
  "nM": "MessageComponents.module__row___UmFBWT",
  "x6": "MessageComponents.module__button___UmFBWT",
  "kX": "MessageComponents.module__success___UmFBWT",
  "Zg": "MessageComponents.module__emoji___UmFBWT",
  "Pf": "MessageComponents.module__label___UmFBWT",
  "Qs": "MessageComponents.module__content___UmFBWT",
  "wP": "MessageComponents.module__linkIcon___UmFBWT",
  "Rm": "MessageComponents.module__secondary___UmFBWT",
  "nf": "MessageComponents.module__link___UmFBWT",
  "OR": "MessageComponents.module__danger___UmFBWT",
};

module.exports = exports;
